import { logger } from '.';
import { DataMutations, MutationResult, ProcessedMutationResults } from '../models/DatamutationsModels';

export const processMutationResults = (
  mutationResults: MutationResult[],
  mutations: DataMutations,
): ProcessedMutationResults => {
  const pendings: Record<string, boolean> = {};
  const errors: Record<string, boolean> = {};
  const successes: Record<string, boolean> = {};

  const mutationData = Object.keys(mutations).reduce<Record<string, unknown>>((acc, key, i) => {
    const result = mutationResults[i];
    logger.log(`Setting data for ${key}`, result);
    acc[key] = result;
    pendings[key] = Boolean(result.isLoading);
    errors[key] = Boolean(result.isError);
    successes[key] = Boolean(result.isSuccess);

    return acc;
  }, {});

  const isMutationPending = Object.values(pendings).some(Boolean);
  const hasMutationError = Object.values(errors).some(Boolean);

  return {
    mutationData,
    errors,
    successes,
    pendings,
    isMutationPending,
    hasMutationError,
  };
};
